var _dec, _class, _descriptor, _descriptor2, _cache, _orderIndex;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { computed } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import rpc from '@banking/api/utils/rpc';
import { Action, GetMessageUnitsRequest, MessageserviceService, TrackEngagementRequest } from '@square/dashboard-protos/models/squareup/messageservice/service';
export const BANKING_HOME_PAGE_PLACEMENT_ID = '7f36d5b5-13c8-4560-a322-d8d201c54b1f';
export const BUSINESS_BANKING_PLACEMENT_ID = '26b9c5f9-a69c-4349-b088-cee75d4b9cc0';
export const BANKING_BALANCE_OVERVIEW_PAGE_PLACEMENT_ID = '643cf245-b7a0-40e1-ae3d-fd9d06c82467';

// GetMessageUnits defaults to 1, so this limit is necessary to fetch messages.
export const BANKING_MESSAGES_LIMIT = 25;
function index([map, set], unit) {
  // TODO(steckel): Consider asserting value we're indexing exists
  map.set(unit.requestToken, unit);
  set.add(unit.requestToken);
  return [map, set];
}
let MessageService = (_dec = computed('capitalEngineContext.headers'), (_class = (_cache = /*#__PURE__*/new WeakMap(), _orderIndex = /*#__PURE__*/new WeakMap(), class MessageService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "sentry", _descriptor2, this);
    // TODO(steckel): Map and Set could be combined with an OrderedMap
    _classPrivateFieldInitSpec(this, _cache, {
      writable: true,
      value: new Map()
    });
    _classPrivateFieldInitSpec(this, _orderIndex, {
      writable: true,
      value: new Map()
    });
  }
  // TODO(steckel): Extract headers into its own service and inject here.
  get client() {
    return MessageserviceService.create(rpc(
    // TODO(steckel): Find a way to test this. This worked in development
    // but broke in staging (when apiHostUrl was passed).
    // NOTE(steckel): avoid passing in apiHostUrl from '@banking/api/utils/rpc'
    // as it will change the RPC endpoint hostname to https://api.* rather
    // than keep it on the same domain and therefore cause CORS issues.
    (_, derivedUrl) => derivedUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  async getMessageUnits(placementId) {
    try {
      if (_classPrivateFieldGet(this, _cache)?.get(placementId) == null) {
        const request = GetMessageUnitsRequest.create({
          placementId,
          limit: BANKING_MESSAGES_LIMIT
        });
        const {
          messageUnits
        } = await this.client.getMessageUnits(request);
        const [cache, orderIndex] = messageUnits.reduce(index, [new Map(), new Set()]);
        _classPrivateFieldGet(this, _cache).set(placementId, cache);
        _classPrivateFieldGet(this, _orderIndex).set(placementId, orderIndex);
      }
      const cachedMessages = _classPrivateFieldGet(this, _cache)?.get(placementId);

      // TODO(steckel): consider assert over !
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return [...cachedMessages.values()];
    } catch (e) {
      this.sentry.captureException(e);
      throw e;
    }
  }
  async peekMessageUnits(placementId) {
    await this.getMessageUnits(placementId);
    if (_classPrivateFieldGet(this, _orderIndex) == null) {
      throw new Error('invariant: #orderIndex should not be nullable');
    }
    if (_classPrivateFieldGet(this, _cache) == null) {
      throw new Error('invariant: #cache should not be nullable');
    }
    const orderIndex = _classPrivateFieldGet(this, _orderIndex).get(placementId);
    const cache = _classPrivateFieldGet(this, _cache).get(placementId);
    if (orderIndex == null) {
      throw new Error('invariant: orderIndex should not be undefined');
    }
    if (cache == null) {
      throw new Error('invariant: #cache should not be undefined');
    }
    return orderIndex.size === 0 ? undefined : cache.get(orderIndex.values().next().value);
  }
  async trackEngagement(placementId, requestToken, action) {
    try {
      if (!_classPrivateFieldGet(this, _cache).get(placementId)?.has(requestToken)) {
        throw new Error('Cannot trackEngagement for MessageUnits not already cached by MessageService.');
      }
      const request = TrackEngagementRequest.create({
        requestToken,
        action
      });
      await this.client.trackEngagement(request);
      if (action === Action.DISMISS) {
        _classPrivateFieldGet(this, _cache).get(placementId)?.delete(requestToken);
        _classPrivateFieldGet(this, _orderIndex).get(placementId)?.delete(requestToken);
      }
    } catch (e) {
      this.sentry.captureException(e);
      throw e;
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype)), _class));
export { MessageService as default };